import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Tras cada navegación: si hay hash (#ancla), hace scroll suave hasta el elemento;
 * si no, sube suavemente al inicio de la página (misma sensación que cookies / sobre nosotros).
 */
export const ScrollToTop = () => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.replace(/^#/, ""));
      let attempts = 0;
      const maxAttempts = 30;

      const tick = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        attempts += 1;
        if (attempts < maxAttempts) {
          requestAnimationFrame(tick);
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
      };

      requestAnimationFrame(tick);
      return;
    }

    // Misma sensación que las anclas (#cookies, #sobre-nosotros): subida suave al inicio
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      });
    });
  }, [pathname, hash, key]);

  return null;
};
